export default "__VITE_ASSET__BTtnlp8a__"